import service from '@/utils/server';

const modName='/bd/orderCreate/';
//查询方法
export const orderSave = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/zhubo/finance/api/index.js